// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"53a13a26","488":"c3995997"}[chunkId] + ".chunk.js";
};